import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'list-ud-book',
  imports: [CommonModule],
  templateUrl: './list-ud-book.atom.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListUdBookAtom implements OnInit {
  @Input() book: any;

  constructor() {}

  ngOnInit(): void {}
}
